import React, { useCallback, useMemo } from "react";
import { useRoute, RouteProp, useNavigation, NavigationProp } from "@react-navigation/native";
import { RootStackParamList } from "../navigation/AppNavigator.web";
import ChatWindowContainer from "../containers/companion/ChatWindowContainer";
import { useGetCompanionChatByIdQuery } from "../graphql/generated/graphql";
import CompanionLayout from "../layouts/CompanionLayout";

function CompanionView() {
  const route = useRoute<RouteProp<RootStackParamList, "Companion Chat">>();
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const { chatId: routeChatId, initialMessage } = route.params || {};

  const { data: routeChatData, loading: routeChatLoading } = useGetCompanionChatByIdQuery({
    skip: !routeChatId,
    variables: {
      id: routeChatId!,
    },
    fetchPolicy: "network-only",
  });

  const resolvedChatId = useMemo(() => {
    if (!routeChatId) {
      return null;
    }
    if (routeChatLoading) {
      return routeChatId;
    }
    if (routeChatData?.getCompanionChatById) {
      return routeChatId;
    }
    return null;
  }, [routeChatId, routeChatLoading, routeChatData]);

  const handleChatIdChange = useCallback(
    (newChatId: string) => {
      navigation.setParams({ chatId: newChatId });
    },
    [navigation]
  );

  const handleInitialMessageConsumed = useCallback(() => {
    navigation.setParams({ initialMessage: undefined });
  }, [navigation]);

  const isLoadingChatId = Boolean(routeChatId) && routeChatLoading;

  return (
    <CompanionLayout>
      <ChatWindowContainer
        chatId={resolvedChatId}
        onChatIdChange={handleChatIdChange}
        isLoadingChatId={isLoadingChatId}
        initialMessage={initialMessage}
        onInitialMessageConsumed={handleInitialMessageConsumed}
      />
    </CompanionLayout>
  );
}

export default CompanionView;
